<template>
  <div class="container">
        <i class="fa fa-check-circle success"></i>
      <h2>Check your email!</h2>
      <span>We've sent you confirmation email to
          <span class="strong">info@devusta.com</span>.
          </span>
        <p>
            You can close this window now and follow the link in your email.
        </p>
  </div>
</template>

<script>
export default {
    name: 'login-form',
    props: {
        msg: String
    }
};
</script>

<style lang="scss" scoped>
</style>
